import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';

export function isOutlookSpacesEnabled() {
    if (isFeatureEnabled('outlookSpaces-enabled')) {
        const { SessionSettings } = getUserConfiguration();
        switch (SessionSettings?.WebSessionType) {
            case WebSessionType.Business:
                return true;
            case WebSessionType.ExoConsumer:
                const isPremium = !!SessionSettings?.IsPremiumConsumerMailbox;
                const isFreeEnabled = isFeatureEnabled('outlookSpaces-free-consumer-enabled');
                return isPremium || isFreeEnabled;
            case WebSessionType.GMail:
                return isFeatureEnabled('outlookSpaces-gmail-enabled');
        }
    }

    return false;
}
